import { Fragment } from "react";
import { Button } from "../../../../../components/ui";

const SectionHeader = props => {
  const { title, actions } = props;
  return (
    <>
      <div className="mb-4 flex w-full flex-col gap-4 font-bold sm:flex-row sm:items-center">
        <div className="flex-1 text-xl">{title}</div>
        <div className="flex flex-wrap gap-4">
          {actions?.map((item, key) => {
            return item?.component ? (
              <Fragment key={key}>{item?.component()}</Fragment>
            ) : (
              <Button
                action={item.type}
                key={key}
                className={item.className}
                label={item.label}
                onClick={item.action}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

export default SectionHeader;
